const _excluded = ["icon", "children"],
  _excluded2 = ["slug", "url"],
  _excluded3 = ["id", "title", "slug", "url", "icon", "onClick"],
  _excluded4 = ["id", "title", "slug", "url", "icon", "onClick", "component"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React, { useState } from "react";
import styled, { css } from "styled-components";
import { MenuSystemIcon } from "@nib/icons";
import { Box, Columns, Column, Hidden, Inline, Container, breakpoint } from "@nib/layout";
import DefaultLogo from "@nib-components/logo";
import Drawer from "@nib/drawer";
import { colorBrandBase, colorLightest } from "@nib-components/theme";
import { LogoLink, NavMenu, baseNavLinkStyles, NavLinkItem, HeaderLink } from "../shared";
const FontZero = styled.div`
  font-size: 0;
`;
export const NavLink = styled.a.attrs({
  "data-testid": "nav-link"
})`
  ${baseNavLinkStyles};

  ${_ref => {
  let {
    isActivePage
  } = _ref;
  return isActivePage && css`
      ::after {
        content: '';
        position: absolute;
        inset-block-end: 0;
        inset-inline: 1rem;
        display: block;
        background: var(--themeColorFgSelected, ${colorBrandBase});
        height: 4px;
      }
    `;
}}
`;
NavLink.displayName = "NavLink";
const PhoneNumberSpan = styled.span`
  unicode-bidi: plaintext;
`;
export const IconLink = _ref2 => {
  let {
      icon: Icon,
      children
    } = _ref2,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(NavLink, otherProps, /*#__PURE__*/React.createElement(Inline, {
    space: 2,
    verticalAlign: "center"
  }, /*#__PURE__*/React.createElement(FontZero, null, /*#__PURE__*/React.createElement(Icon, {
    size: 20
  })), /*#__PURE__*/React.createElement(PhoneNumberSpan, null, children)));
};
const HiddenBelowXLFlexAbove = styled.div`
  display: none;

  ${breakpoint("xl")`
    display: flex;
  `}
`;
HiddenBelowXLFlexAbove.displayName = "HiddenBelowXLFlexAbove";
const FlexBelowXLHiddenAbove = styled.div`
  display: flex;

  ${breakpoint("xl")`
    display: none;
  `}
`;
FlexBelowXLHiddenAbove.displayName = "FlexBelowXLHiddenAbove";
const BoxBorderBottom = styled(Box)`
  border-bottom: 1px solid var(--smallHeaderColorBorderDivider, ${colorLightest});
`;
BoxBorderBottom.displayName = "BoxBorderBottom";
const ColumnPullLeft = styled(Column)`
  margin-inline-end: auto;
`;
const UnstyledUnorderedList = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
`;
UnstyledUnorderedList.displayName = "UnstyledUnorderedList";
const FlexListItem = styled.li`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
`;
FlexListItem.displayName = "FlexListItem";
const TierOne = props => /*#__PURE__*/React.createElement(BoxBorderBottom, {
  "data-testid": "tier-one"
}, props.children);
const TierTwo = props => /*#__PURE__*/React.createElement(Box, {
  "data-testid": "tier-two",
  as: "nav",
  "aria-label": "Main navigation"
}, props.children);
export const PortalHeader = props => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const {
    logo: Logo,
    withContainer = false,
    isSingleTier = false,
    activePage,
    navLinks = [],
    iconLinks = [],
    logoLinkProps,
    drawerChildren,
    navSlot
  } = props;
  const ConditionalContainer = withContainer ? Container : "div";
  const DefaultOrCustomLogo = Logo || DefaultLogo;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Drawer, {
    navLinks: navLinks,
    isOpen: isDrawerOpen,
    setIsOpen: setIsDrawerOpen,
    hideQuoteButton: true,
    navSlot: navSlot
  }, drawerChildren), /*#__PURE__*/React.createElement(TierOne, null, /*#__PURE__*/React.createElement(ConditionalContainer, null, /*#__PURE__*/React.createElement(Columns, {
    align: "right",
    wrap: true
  }, /*#__PURE__*/React.createElement(ColumnPullLeft, {
    width: "content",
    flex: true
  }, /*#__PURE__*/React.createElement(LogoLink, _extends({
    href: "/",
    id: "ga-nav-logo"
  }, logoLinkProps), /*#__PURE__*/React.createElement(DefaultOrCustomLogo, null))), /*#__PURE__*/React.createElement(HiddenBelowXLFlexAbove, null, isSingleTier && navLinks && /*#__PURE__*/React.createElement("nav", null, /*#__PURE__*/React.createElement(UnstyledUnorderedList, null, navLinks.map((link, i) => {
    const {
        slug,
        url
      } = link,
      otherProps = _objectWithoutProperties(link, _excluded2);
    return /*#__PURE__*/React.createElement(NavLinkItem, _extends({
      key: `${slug}-${i}`,
      link: link,
      href: url,
      activePage: props.activePage,
      navLink: NavLink,
      dropdownIconSize: 20
    }, otherProps), link.title);
  }))), iconLinks && /*#__PURE__*/React.createElement(UnstyledUnorderedList, null, iconLinks.map(link => {
    const {
        id,
        title,
        slug,
        url,
        icon: Icon,
        onClick
      } = link,
      otherProps = _objectWithoutProperties(link, _excluded3);
    return /*#__PURE__*/React.createElement(FlexListItem, {
      key: slug
    }, /*#__PURE__*/React.createElement(IconLink, _extends({
      href: url,
      icon: Icon,
      id: `${id}-desktop`,
      onClick: onClick && onClick
    }, otherProps), title));
  }))), /*#__PURE__*/React.createElement(FlexBelowXLHiddenAbove, null, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    style: {
      flexWrap: "wrap"
    }
  }, iconLinks && iconLinks.map((link, i) => {
    const {
        id,
        title,
        slug,
        url,
        icon,
        onClick,
        component
      } = link,
      otherProps = _objectWithoutProperties(link, _excluded4);
    const Icon = icon;
    return /*#__PURE__*/React.createElement(HeaderLink, _extends({
      key: `${slug}-${i}`,
      href: url,
      icon: Icon,
      id: `${id}-mobile`,
      "aria-label": title,
      component: component || "a",
      onClick: onClick && onClick
    }, otherProps), /*#__PURE__*/React.createElement(Icon, null));
  }), /*#__PURE__*/React.createElement(HeaderLink, {
    component: "button",
    id: "ga-nav-menu-mobile",
    onClick: () => {
      setIsDrawerOpen(true);
    },
    "aria-label": "Open menu"
  }, /*#__PURE__*/React.createElement(MenuSystemIcon, null))))))), !isSingleTier && /*#__PURE__*/React.createElement(Hidden, {
    below: "xl"
  }, /*#__PURE__*/React.createElement(TierTwo, null, /*#__PURE__*/React.createElement(ConditionalContainer, null, /*#__PURE__*/React.createElement(NavMenu, null, navLinks && navLinks.map(link => /*#__PURE__*/React.createElement(NavLinkItem, _extends({
    link: link,
    activePage: activePage,
    key: link.id
  }, link, {
    navLink: NavLink,
    dropdownIconSize: 20
  }))), navSlot && navSlot)))));
};
PortalHeader.displayName = "PortalHeader";